import React from 'react';
import PropTypes from 'prop-types';
import PressHero from '../image-hero/image-hero';
import SpecialistsCategory from './specialists-category/specialists-category';
import SpecialistsArticle from './specialists-article/specialists-article';

const SpecialistsPage = ({ specialistsData }) => (
  <div className="specialists-page">
    <PressHero
      backgroundClassName="press-specialists-hero"
      preheader="Specialists"
      title="Meet our nerdiest nerds "
      body="Get to know our thought leaders and experienced pros."
      bodyMobile="Get to know our thought leaders and experienced pros."
      opacityLevel={0.78}
    />
    <SpecialistsCategory articles={specialistsData.data} />
  </div>
);

SpecialistsPage.displayName = 'SpecialistsPage';

SpecialistsPage.propTypes = {
  specialistsData: PropTypes.shape({
    data: PropTypes.arrayOf(SpecialistsArticle.propTypes.article),
  }),
};

export default SpecialistsPage;
